import React from 'react';
/**
 * @TODO - Implement MessengerMessage component
 * @param message - Messenger message object
 */
const MessengerMessage = ({ message }) => {
    return React.createElement("div", null, "Messenger message");
};
export default MessengerMessage;
